import Vue from 'vue';

export default {
  /**
   * Helper method for making POST HTTP requests.
   */
  post (uri, form) {
    return Http.sendForm('post', uri, form);
  },

  /**
   * Helper method for making PUT HTTP requests.
   */
  put (uri, form) {
    return Http.sendForm('put', uri, form);
  },

  /**
   * Helper method for making DELETE HTTP requests.
   */
  delete (uri, form) {
    return Http.sendForm('delete', uri, form);
  },

  /**
   * Send the form to the back-end server.
   *
   * This function will clear old errors, update "busy" status, etc.
   */
  sendForm (method, uri, form) {
    return new Promise((resolve, reject) => {
      form.startProcessing();

      const body = JSON.parse(JSON.stringify(form));
      let config = body;

      // if is NOT post put or patch, use { body }
      if (['post', 'put', 'patch'].indexOf(method) === -1) {
        config = { body };
      }

      Vue.http[method](uri, config)
        .then((response) => {
          form.finishProcessing();

          resolve(response.data);
        })
        .catch((response) => {
          form.errors.set(response.data);
          form.busy = false;

          console.log(response.status);

          reject(response.data);
        });
    });
  },
};
